import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { D as Drawer } from './Drawer-NMc-EopI.js';
import { selectCurrentCurrencyCode } from './storeSelectors/currencies.js';
import { selectShowMobileMenu } from './storeSelectors/modal.js';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import useAuthenticated from './hooks/useAuthenticated.js';
import './index-dEXHnASi.js';
import 'notistack';
import { getCookie } from './utils/cookies.js';
import { b as COOKIE_CURRENCY_NAME } from './cookies-VX_DpI1q.js';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-WYINLSKJ.js';
import { C as CurrencyCode } from './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-a4IKjS7g.js';
import 'lodash';
import IconButton from './components/IconButton/index.js';
import { ActionType, UtilityIcons } from './types/index.js';
import './checkout-Ee1eEXQH.js';
import './menu-0TyOg98i.js';
import './modal-6vnX5SO3.js';

const MobileMenu = ({ onAction }) => {
    var _a, _b;
    const { t: tHeading } = useTranslation('', { keyPrefix: '$common.$headings' });
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { data: { siteConfig: { header: { mobileMenuIconOrder = [ActionType.Language, ActionType.Currency] } = {}, } = {}, }, actions: { modal: { toggleShowMobileMenu }, }, useSelector, useDispatch, } = useContext(CoreContext);
    const { locale } = useRouter();
    const isLogged = useAuthenticated();
    const dispatch = useDispatch();
    const showMenu = useSelector(selectShowMobileMenu);
    const currencyCode = (_a = useSelector(selectCurrentCurrencyCode)) !== null && _a !== void 0 ? _a : CurrencyCode.EUR;
    const currencyCookie = getCookie(COOKIE_CURRENCY_NAME);
    const currencyDisplay = (_b = useSelector(selectCurrentCurrencyCode)) !== null && _b !== void 0 ? _b : currencyCookie;
    const toggleShowMenu = () => {
        dispatch(toggleShowMobileMenu(!showMenu));
    };
    const onKeyUp = (e, action) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.key === ' ' || e.key === 'Enter') {
            onAction(action);
        }
    };
    const currencyIcon = currencyDisplay ? currencyDisplay.toLocaleLowerCase() : 'eur';
    const actionElements = {
        [UtilityIcons.Language]: (React.createElement("li", { key: "language" },
            React.createElement("div", { role: "button", className: "inner", tabIndex: 0, onKeyPress: e => onKeyUp(e, ActionType.Language), onClick: () => onAction(ActionType.Language) },
                React.createElement("div", { className: "icon-wrapper" },
                    React.createElement("i", { className: "icon-location" })),
                React.createElement("div", { className: "text-wrapper" },
                    React.createElement("div", { className: "title" }, tHeading('languageSelection')),
                    React.createElement("div", { "data-testid": `language-code-${locale.toLowerCase()}` },
                        `${tLabel('selected')}: `,
                        React.createElement("span", { className: "language-code" }, locale)))))),
        [UtilityIcons.Search]: React.createElement("li", { key: "search" }),
        [UtilityIcons.Currency]: (React.createElement("li", { key: "currency" },
            React.createElement("div", { role: "button", className: "inner", tabIndex: 0, onKeyPress: e => onKeyUp(e, ActionType.Currency), onClick: () => onAction(ActionType.Currency) },
                React.createElement("div", { className: "icon-wrapper" },
                    React.createElement("i", { className: `icon-${currencyIcon}` })),
                React.createElement("div", { className: "text-wrapper" },
                    React.createElement("div", { className: "title" }, tLabel('currencySelection')),
                    React.createElement("div", { "data-testid": `currency-${currencyCode.toLowerCase()}` }, `${tLabel('selected')}: ${currencyCode}`))))),
        [UtilityIcons.Account]: (React.createElement("li", { key: "account" },
            React.createElement("div", { role: "button", className: "inner", tabIndex: 0, onKeyPress: e => onKeyUp(e, ActionType.Account), onClick: () => onAction(ActionType.Account) },
                React.createElement("div", { className: "icon-wrapper" },
                    React.createElement("i", { className: "icon-user" })),
                React.createElement("div", { className: "text-wrapper" },
                    React.createElement("div", { className: "title" }, tLabel('myAccount')),
                    !isLogged && React.createElement("div", { dangerouslySetInnerHTML: { __html: tHeading('loginHeading') } }))))),
        [UtilityIcons.ShoppingCart]: React.createElement("li", { key: "cart" }),
    };
    return mobileMenuIconOrder.length ? (React.createElement("div", { id: "mobile-menu" },
        React.createElement(IconButton, { testId: "open-menu", btnClassName: "ab-icon icon-mobile-menu", iconClassName: "icon-drawer", title: tLabel('moreOptions'), onClick: toggleShowMenu }),
        React.createElement(Drawer, { open: showMenu, onClose: toggleShowMenu, name: "mobile-menu" },
            React.createElement("div", { className: "mobile-menu-popup" },
                React.createElement("ul", null, mobileMenuIconOrder.map(action => actionElements[action])))))) : null;
};

export { MobileMenu as M };
//# sourceMappingURL=MobileMenu-uxhygBnZ.js.map
